import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Observable, Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Api } from '../../../../_models';
import { CustomerService } from '../../../../_services';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { DataService } from 'src/app/_helpers';

@Component({
  selector: 'app-api-key',
  templateUrl: './api-key.component.html',
  styleUrls: [
    './api-key.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-buttons-theme.css'
  ]
})
export class ApiKeySubComponent implements OnInit {

  icons: typeof icons;
  @Input() customerPublicId: string;

  apiKeyForm: FormControl = new FormControl('', [Validators.required]);
  confirmApiKeyUpdateCheckbox: FormControl = new FormControl(false);

  apiKey$: Observable<Api>;
  isApiKeyFormChange: boolean;
  isUpdateBtnEnable: boolean = true;
  initialFormValue: string;
  updateSucess: boolean = false;
  updateError: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private dataService: DataService
  ) {
    this.icons = icons;
  }

  ngOnInit() {
    this.dataService.loadSpinner(true);
    this.setApiKeyObservable();
  }

  //  forms' setters and getters
  get confirmApiKeyUpdateCheckboxControl(): boolean { return this.confirmApiKeyUpdateCheckbox.value; }
  set confirmApiKeyUpdateCheckboxControl(value: boolean) {
    this.confirmApiKeyUpdateCheckbox.setValue(value);
  }

  get apiKeyControl(): string { return this.apiKeyForm.value; }
  set apiKeyControl(value: string) {
    this.apiKeyForm.setValue(value);
  }

  updateApiKey(newApiKey: FormControl) {
    this.dataService.loadSpinner(true);
    this.isUpdateBtnEnable = false;
    const apiKeyPayload = {
      value: newApiKey.value
    };

    this.customerService.updateAPI(apiKeyPayload, this.customerPublicId)
      .pipe(tap(data => {
        this.initialFormValue = data.value;
        this.isApiKeyFormChange = false;
        this.confirmApiKeyUpdateCheckboxControl = false;

        this.updateSucess = true;
        this.updateError = false;
        this.isUpdateBtnEnable = true;
        this.dataService.loadSpinner(false);
      }),
        catchError(error => {
          this.updateSucess = false;
          this.updateError = true;
          this.isUpdateBtnEnable = true;
          this.dataService.loadSpinner(false);
          console.log('Failed! while trying to update the API key.', error);
          return of(null)
        })
      )
      .subscribe();
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  canSave() {
    this.isApiKeyFormChange = this.initialFormValue !== this.apiKeyForm.value;
    this.updateSucess = false;
    this.updateError = false;
    if (!this.isApiKeyFormChange) {
      this.confirmApiKeyUpdateCheckboxControl = false;
    }
  }

  setApiKeyObservable() {
    this.apiKey$ = this.customerService.getApiDetails(this.customerPublicId)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          this.apiKeyControl = data.value;
          this.initialFormValue = this.apiKeyForm.value;
          this.apiKeyForm.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.canSave());
            this.dataService.loadSpinner(false);
        }),
        catchError(err => {
          console.error('Failed while trying to get api key. ' + err);
          this.dataService.loadSpinner(false);
          return of({ value: '' })
        })
      )
  }

  generateRandomString(stringLength: number) {
    let random_string = '';
    let random_ascii;
    let ascii_low = 0;
    let ascii_high = 99;
    let newValue = '';
    for (let i = 0; i < stringLength; i++) {
      random_ascii = Math.floor((Math.random() * (ascii_high - ascii_low)) + ascii_low);
      random_string += String.fromCharCode(random_ascii);
      newValue = btoa(random_string += String.fromCharCode(random_ascii));
    }
    this.apiKeyControl = newValue;
    return newValue;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
